// @core/api/endpoints/subscription/purchase_add_on.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  PurchaseAddOnRequest,
  PurchaseAddOnResponse,
} from '../../../types/subscription';

const BASE_PATH = '/subscription';

/**
 * Purchase addon
 * Purchases an addon for an existing subscription. Creates a new subscription item and grants associated entitlements.
 */
export async function PurchaseAddOn(
  subscription_id: string,
  data: PurchaseAddOnRequest,
  options?: RequestOptions
): Promise<PurchaseAddOnResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/subscriptions/:subscription_id/addons`;
  requestPath = requestPath.replace(':subscription_id', encodeURIComponent(subscription_id));
  const requestOptions = options;
  return client.post<PurchaseAddOnResponse>(requestPath, data, requestOptions);
}
